export default __webpack_public_path__ + "static/media/pattern9.eebfabbd.png";